import React from 'react';
import { DynamicDashboard } from '@/shared/components/dashboard';
import { useAuth } from '@/features/auth/hooks/useAuth';

export const TeacherDashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <DynamicDashboard
      title={`Bonjour, ${user?.firstName}`}
      // A professor whose new year has no timetable yet must still be able to
      // consult the year they actually taught.
      academicYearSelector
    />
  );
};
